import React from 'react';
import PropTypes from 'prop-types';
import { BreakpointProvider } from '@tamagoshi/core/MediaQuery';
import { IntlContextProvider, FooterProvider } from './context';
import Footer from './Footer';
import { initialState as defaultState } from './store';
import { LOCALES } from './constants';

const FooterContainer = ({ state: initialState, translations }) => (
  <IntlContextProvider translations={translations}>
    <FooterProvider initialState={initialState}>
      <BreakpointProvider>
        <Footer />
      </BreakpointProvider>
    </FooterProvider>
  </IntlContextProvider>
);

FooterContainer.propTypes = {
  translations: PropTypes.exact({
    messages: PropTypes.object,
    addLocaleData: PropTypes.func.isRequired,
    locale: PropTypes.oneOf(Object.values(LOCALES)),
  }).isRequired,
  state: FooterProvider.propTypes.initialState,
};

FooterContainer.defaultProps = {
  state: defaultState,
};

export default FooterContainer;
